import axios from 'axios';
import { apiName } from '@/api/api.js'
let base = apiName;

//编辑角色名称
export const requestOverstockList = async params => {
    const res = await axios({ method: 'post', url: `${base}/overstock/overstocklist`, params: params });
    return res.data;
};

